import { render, staticRenderFns } from "./EnquiryReservationForm.vue?vue&type=template&id=67bc1fe0&"
import script from "./EnquiryReservationForm.vue?vue&type=script&lang=js&"
export * from "./EnquiryReservationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports